// extracted by mini-css-extract-plugin
export default {"background":"FP","weightImage":"GP","drinkImage":"HP","content":"IP","rtbLeft":"JP","rtbRight":"KP","rtbLeftMobile":"LP","imageContainer":"MP","rtbBox":"NP","line":"OP","rtbDesktop":"PP"};
    if(module.hot) {
      // 1715632478447
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  